const swiper = new Swiper(".glx__Swiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  });

  /*
  document.addEventListener("DOMContentLoaded", function() {
  OverlayScrollbars(document.querySelectorAll(".thumbnail-list"), {
    className: "os-theme-dark",
    scrollbars: {
      autoHide: "leave",
      autoHideDelay: 500
    }
  });
});*/


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".order-delivery-timer").forEach(function (el) {
    const cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    const deliveryDays = parseInt(el.dataset.deliveryDays, 10);
    const timezone = el.dataset.timezone;
    const labelBefore = el.dataset.labelBefore;
    const labelAfter = el.dataset.labelAfter;
    const expiredLabel = el.dataset.expiredLabel;

    // Use shop/site language automatically (fr-FR, en-GB, etc.)
    const locale =
      (document.documentElement.lang && document.documentElement.lang.trim()) ||
      navigator.language ||
      "en-US";

    function updateTimer() {
      const now = new Date();
      const local = new Date(now.toLocaleString("en-US", { timeZone: timezone }));

      const cutoff = new Date(local);
      cutoff.setHours(cutoffHour, 0, 0, 0);

      let shippingDate = new Date(local);
      let timeLeft = cutoff - local;

      if (timeLeft <= 0) {
        // after cutoff → next day
        shippingDate.setDate(local.getDate() + 1);
        timeLeft = 0;
      }

      // delivery date = shipping date + deliveryDays (skip weekends)
      let deliveryDate = new Date(shippingDate);
      let added = 0;
      while (added < deliveryDays) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        const day = deliveryDate.getDay();
        if (day !== 0 && day !== 6) added++;
      }

      const deliveryStr = deliveryDate.toLocaleDateString(locale, {
        weekday: "long",
        month: "long",
        day: "numeric",
      });

      if (timeLeft > 0) {
        const hours = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        el.innerHTML = `${labelBefore} <b>${hours}h ${minutes}m ${seconds}s</b> ${labelAfter} <b>${deliveryStr}</b>`;
      } else {
        el.innerHTML = `${expiredLabel} <b>${deliveryStr}</b>`;
      }
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  });
});